import { selectCountries } from 'legacy/lut/selectors/app'
import { useCountriesMappedByCode } from 'legacy/shared/hooks/useCountriesMappedByCode'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { CHINA_COUNTRY_ISO } from 'onboarding/components/widgets/public/request/contract/constants'

export const useTerritoryOfSaleRootAPJ = (partnerCountryName: string) => {
  const countries = useSelector(selectCountries)
  const codesToCountries = useCountriesMappedByCode()

  return useMemo(() => {
    const china = codesToCountries.get(CHINA_COUNTRY_ISO)
    if (china?.name === partnerCountryName) {
      return `Market-${china.market}`
    }

    const country = countries.find((i) => i.name === partnerCountryName)

    return country?.hporg ? `Org-${country?.hporg}` : undefined
  }, [partnerCountryName, countries, codesToCountries])
}
